import { render, staticRenderFns } from "./WizardThirdStep.vue?vue&type=template&id=35b1e25c&"
import script from "./WizardThirdStep.vue?vue&type=script&lang=js&"
export * from "./WizardThirdStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports